/**
 * @ngdoc config
 * @name httpProviderConfig
 * @description
 * Push the `authInterceptor` service into the list of `$http` interceptors.
 *
 * @param {Service} $httpProvider The interface to configure the `$http` service.
 * @memberof account
 */
const httpProviderConfig = ($httpProvider) => {
  'ngInject';

  $httpProvider.interceptors.push('authInterceptor');
};

export default httpProviderConfig;



// WEBPACK FOOTER //
// ./src/frontend/modules/account/configs/httpProvider.config.js